import type { ReasonCodeGroup } from '~/flow/types';
import type {
  Action,
  DataRoute,
  Dependency,
  EngineValidationData,
  Expression,
  OutcomeObjectInAction,
  ReasonCode,
  ReasonCodeGroupMap,
  Rules,
  ServiceAttributeMap,
  TagObjectInAction,
  Threshold,
} from '../../../store/engine/types';

export type SingleItemData = Partial<(TagObjectInAction | OutcomeObjectInAction)
& Record<string, string | number | ReasonCodeGroup>>;

export type MultiItemData = Record<string, string | number | ReasonCodeGroup>[];

export type MissingRequiredItemInfoObject = {
  type: string;
  name: string;
  status: string;
  data: SingleItemData | MultiItemData;
  result?: OutcomePayloadInTags | string | number | ReasonCodeGroup & {
    customer_reason_code_group_id: number;
    updated: boolean;
  };
  retry?: ReasonCode[] | string[];
};

export type MissingRequiredItemInfo = MissingRequiredItemInfoObject[];

export type OutcomePayloadInTags = {
  outcome: string;
  color: string;
  archived: boolean;
  is_case_status: boolean;
};

export type TagPayloadData = {
  customer_tag_id?: number | null;
  category_id: number | null;
  is_case_creating: boolean | null;
  suppression_interval: number | {
    unit: string;
    value: number;
  } | null;
  tag_color: string;
  tag_name: string;
  outcomes?: OutcomePayloadInTags[] | null;
};

export type PendingImportData = {
  actions: Record<string, Action>;
  thresholds: Record<string, Threshold>;
  dataRoutes: Record<string, DataRoute>;
  dependencies?: Record<string, Dependency> | {};
  rulesPendingMerge?: Record<string, Rules>;
  expressionsPendingMerge?: Record<string, Expression>;
  jsonData?: {
    actions: Record<string, Action>;
    thresholds: Record<string, Threshold>;
    dataRoutes: Record<string, DataRoute>;
    serviceAttributeData: ServiceAttributeMap;
    reasonCodeGroupData: ReasonCodeGroupMap;
  };
  validations: EngineValidationData;
  type: WorkflowJSONType;
};

export enum WorkflowJSONType {
  PARTIAL = 'partial',
  FULL = 'full',
}
